export const ptBR = {
  auth: {
    login: "Entrar",
    signUp: "Criar Conta",
    logout: "Sair",
    email: "Email",
    password: "Senha",
    username: "Nome de usuário",
    loginSubtitle: "Bem-vindo de volta, amante de café",
    signupSubtitle: "Junte-se à comunidade do café",
    loginDescription: "Entre com suas credenciais para acessar sua conta",
    signupDescription: "Crie sua conta para começar a compartilhar cafés",
    createAccount: "Criar Conta",
    noAccount: "Não tem uma conta?",
    haveAccount: "Já tem uma conta?",
    alreadyMember: "Já é membro?",
    signIn: "Entre.",
    signingIn: "Entrando...",
    creatingAccount: "Criando conta...",
    loginError: "Falha no login",
    signupError: "Falha ao criar conta",
    signupSuccess: "Conta criada!",
    checkEmail: "Verifique seu email para confirmar sua conta.",
    welcomeBack: "Bem-vindo de volta!",
    usernameError: "Nome de usuário inválido",
    usernameTooShort: "O nome de usuário deve ter pelo menos 3 caracteres.",
    usernameInvalid: "O nome de usuário só pode conter letras, números e underscores.",
    usernameHint: "Apenas letras, números e underscores",
    passwordHint: "Pelo menos 6 caracteres",
    welcomeTitle: "Olá, bem-vindo de volta",
    welcomeSubtitle: "Que bom ver você novamente!",
    forgotPassword: "Esqueceu a senha?",
    orSignUp: "Ou cadastre-se",
    emailPlaceholder: "seu.email@endereco.com",
    passwordPlaceholder: "Digite sua senha",
    signupWelcomeTitle: "Crie sua conta",
    signupWelcomeSubtitle: "Junte-se à comunidade do café",
    orSignIn: "Ou entre",
    // Roaster-specific auth strings
    roasterLoginSubtitle: "Entre no painel da sua torrefadora",
    roasterEmailPlaceholder: "voce@torrefadora.com",
    roasterNamePlaceholder: "Torrefadora Incrível",
    roasterSignupTitle: "Comece a coletar feedback",
    roasterSignupSubtitle: "Crie sua conta de torrefador gratuitamente",
    roasterNameTooShort: "O nome da torrefadora deve ter pelo menos 2 caracteres",
    passwordResetComingSoon: "Redefinição de senha em breve",
    termsAgreement: "Ao se cadastrar, você concorda com nossos Termos de Serviço e Política de Privacidade.",
    // Branding panel
    brandingTitle: "Conheça Seus Clientes",
    brandingDescription: "Colete feedback, analise tendências e faça um café melhor com insights de IA dos seus clientes.",
    statsFeedback: "Feedback coletados",
    statsRoasters: "Torrefadoras",
  },
  common: {
    grinder: "Moedor",
    electric: "Elétrico",
    manual: "Manual",
    save: "Salvar",
    cancel: "Cancelar",
    delete: "Excluir",
    edit: "Editar",
    somethingWentWrong: "Algo deu errado",
    errorOccurred: "Ocorreu um erro",
    errorLoadingData: "Não foi possível carregar os dados. Por favor, tente novamente.",
    retry: "Tentar novamente",
    tryAgain: "Tentar novamente",
    openMenu: "Abrir menu",
    closeMenu: "Fechar menu",
    load: "Carregar",
    offset: "Offset",
    steps: "passos",
    clicks: "clicks",
    rotations: "voltas",
    position: "Posição",
    beans: "Grãos",
    processing: "Processando...",
    uploadSuccess: "Imagem enviada!",
    uploadError: "Falha ao enviar imagem",
    imageRemoved: "Imagem removida",
    deleteError: "Falha ao excluir imagem",
    notFound: "Não Encontrado",
    saving: "Salvando...",
    clearAll: "Limpar tudo",
  },
  storage: {
    bucketNotFound: "Armazenamento não configurado. Por favor, contate o suporte.",
    permissionDenied: "Permissão negada. Por favor, faça login e tente novamente.",
    fileTooLarge: "Arquivo muito grande. Por favor, escolha um arquivo menor.",
    invalidFileType: "Tipo de arquivo inválido. Use JPEG, PNG, WebP ou GIF.",
    networkError: "Erro de rede. Verifique sua conexão e tente novamente.",
  },
  header: {
    title: "CoffeeLog",
    subtitle: "Calibração Profissional",
    lightTheme: "Tema claro",
    darkTheme: "Tema escuro",
  },
  nav: {
    contact: "Contato",
    joinForFree: "Cadastre-se Grátis",
  },
  slider: {
    realSteps: "Passos Reais",
    fineToCoarse: "Fino ← → Grosso",
    min: "Min",
    max: "Max",
    zero: "Zero",
    settingsLabel: "Configurações de Moagem",
  },
  brewMethods: {
    title: "Métodos de Preparo",
    subtitle: "Selecione para ajustar automaticamente",
    selected: "Selecionado",
    steps: "passos",
  },
  calibration: {
    currentSetting: "Configuração Atual",
    instructions: "Instruções",
    followSteps: "Siga os passos abaixo",
    step1Title: "Posicione no Zero",
    step1Desc: "Alinhe o dial com",
    step2Title: "Gire Anti-Horário",
    rotation: "volta",
    rotations: "voltas",
    step3Title: "Posição Final",
    markAt: "Marca em",
    total: "Total",
    turningClockwise: "rodando em sentido horário",
  },
  calibrate: {
    guestHeading: "Domine suas configurações de moagem",
    guestDescription: "Encontre a moagem perfeita para qualquer método de preparo. Cadastre-se para salvar suas calibrações e acessá-las a qualquer momento.",
  },
  history: {
    title: "Histórico",
    empty: "Nenhuma calibração salva",
    emptyDesc: "Salve suas calibrações favoritas para acessá-las rapidamente depois. Suas configurações ficam armazenadas localmente.",
    savedCalibration: "calibração salva",
    savedCalibrations: "calibrações salvas",
    favorites: "Favoritos",
    recent: "Recentes",
    hideNotes: "Ocultar observações",
    showNotes: "Ver observações",
    notes: "Observações",
    offset: "Offset",
    steps: "Passos",
    rotations: "Voltas",
    addNotesPlaceholder: "Adicione observações...",
  },
  saveDialog: {
    title: "Salvar Calibração",
    nameLabel: "Nome da calibração",
    namePlaceholder: "Ex: V60 café médio",
    notesLabel: "Observações",
    notesPlaceholder: "Adicione detalhes sobre o café, resultado da extração...",
    optional: "(opcional)",
    required: "*",
    saveButton: "Salvar Calibração",
  },
  deleteDialog: {
    title: "Excluir calibração?",
    description: "Esta ação não pode ser desfeita. A calibração \"{name}\" será removida permanentemente.",
    confirm: "Excluir",
  },
  actions: {
    load: "Carregar",
    favorite: "Favoritar",
    unfavorite: "Desfavoritar",
    edit: "Editar",
    delete: "Excluir",
  },
  toasts: {
    grinderSelected: "{grinder}",
    settingsReset: "Moedor selecionado. Configurações resetadas.",
    methodSelected: "{method} selecionado",
    calibrationSet: "Calibração ajustada para {steps} passos reais ({grindLevel})",
    calibrationSaved: "Calibração salva!",
    addedToHistory: "\"{name}\" foi adicionada ao histórico.",
    calibrationLoaded: "Calibração carregada",
    appliedToDial: "\"{name}\" aplicada ao dial.",
    calibrationDeleted: "Calibração excluída",
    removedFromHistory: "A calibração foi removida do histórico.",
  },
  footer: {
    tagline: "CoffeeLog · Calibração profissional para moedores de café",
    stepsNote: "100 passos = 1 volta completa",
  },
  grindLevels: {
    ultraFine: "Ultra Fino",
    fine: "Fino",
    mediumFine: "Médio-Fino",
    medium: "Médio",
    mediumCoarse: "Médio-Grosso",
    coarse: "Grosso",
    extraCoarse: "Extra Grosso",
  },
  grinderInfo: {
    title: "Seu Moedor",
    imagePlaceholder: "Imagem do Moedor",
    maxSteps: "Passos Máximos",
    stepsPerRotation: "Passos/Volta",
    unit: "Unidade",
    showInstructions: "Mostrar instruções",
    hideInstructions: "Ocultar instruções",
    specifications: "Especificações",
  },
  offsetTooltip: "Offset é a diferença entre o zero marcado e o zero real. Padrão: {default}.",
  social: {
    home: "Início",
    feed: "Feed",
    feedDesc: "Veja o que os amantes de café que você segue estão preparando",
    discover: "Descobrir",
    myBrews: "Meus Cafés",
    saved: "Salvos",
    collection: "Coleção",
    collectionDesc: "Seus cafés e favoritos salvos em um só lugar.",
    profile: "Perfil",
    create: "Criar",
    navigation: "Navegação",
    tools: "Ferramentas",
    calibrator: "Calibrador",
    searchPlaceholder: "Buscar cafés, usuários...",
    shareBrew: "Compartilhar Café",
    welcomeTitle: "Bem-vindo ao CoffeeLog",
    welcomeDesc: "Entre para seguir entusiastas do café e compartilhar seus cafés com a comunidade.",
    noBrews: "Nenhum café ainda",
    noBrewsHomeDesc: "Siga outros amantes do café ou compartilhe seu primeiro café para começar!",
    noBrewsDiscoverDesc: "Seja o primeiro a compartilhar um café com a comunidade!",
    noBrewsSavedDesc: "Salve cafés que você quer experimentar depois.",
    loadingBrews: "Carregando cafés...",
    exploreDiscover: "Explorar Descobrir",
    copySettings: "Copiar Configurações",
    settingsCopied: "Configurações copiadas!",
    settingsCopiedDesc: "Configurações de calibração do café de @{user} aplicadas.",
    brewSaved: "Café salvo!",
    brewUnsaved: "Café removido dos salvos.",
    loginRequired: "Por favor, entre para fazer isso.",
    discoverDesc: "Explore cafés públicos da comunidade.",
    savedDesc: "Cafés que você salvou para depois.",
    myBrewsDesc: "Todos os seus cafés compartilhados.",
    // Phase 3 additions
    follow: "Seguir",
    unfollow: "Deixar de seguir",
    followers: "Seguidores",
    following: "Seguindo",
    followsYou: "Segue você",
    noFollowers: "Nenhum seguidor ainda",
    noFollowing: "Não segue ninguém",
    nowFollowing: "Agora seguindo @{username}",
    unfollowed: "Deixou de seguir @{username}",
    brews: "Cafés",
    userBrews: "Cafés",
    profileOverview: "Visão Geral",
    favoriteGrinder: "Moedor favorito",
    memberSince: "Membro desde",
    createBrew: "Compartilhar um Café",
    createBrewDesc: "Compartilhe seu café com a comunidade",
    coffeeName: "Nome do Café",
    coffeeOrigin: "Origem",
    roaster: "Torrefadora",
    grinder: "Moedor",
    selectGrinder: "Selecione o moedor",
    brewMethod: "Método de Preparo",
    selectMethod: "Selecione o método",
    notes: "Observações",
    notesPlaceholder: "Notas de degustação, detalhes da extração...",
    makePublic: "Tornar público",
    publicDesc: "Qualquer pessoa pode ver este café",
    sharing: "Compartilhando...",
    fillRequired: "Por favor, preencha todos os campos obrigatórios",
    brewCreated: "Café compartilhado!",
    brewCreateError: "Falha ao compartilhar café",
    // Image upload
    imageUpload: "Foto",
    imageUploadHint: "Adicione uma foto do seu café (opcional)",
    dragDropImage: "Arraste e solte ou clique para enviar",
    maxFileSize: "Máx 5MB",
    allowedFormats: "JPEG, PNG, WebP, GIF",
    removeImage: "Remover imagem",
    uploadingImage: "Enviando...",
    moderatingImage: "Verificando imagem...",
    // Moderation errors
    imageRejected: "Imagem rejeitada",
    imageExplicitContent: "A imagem contém conteúdo inapropriado",
    imageViolence: "A imagem contém conteúdo violento",
    imageOffensive: "A imagem contém conteúdo ofensivo",
    imageTooLarge: "A imagem é muito grande (máx 5MB)",
    imageInvalidType: "Tipo de arquivo inválido. Use JPEG, PNG, WebP ou GIF",
    // Edit/Delete
    editBrew: "Editar Café",
    editBrewDesc: "Atualize os detalhes do seu café",
    deleteBrew: "Excluir Café",
    deleteBrewConfirm: "Tem certeza que deseja excluir este café?",
    deleteBrewDesc: "Esta ação não pode ser desfeita. O café será removido permanentemente.",
    brewUpdated: "Café atualizado!",
    brewUpdateError: "Falha ao atualizar café",
    brewDeleted: "Café excluído!",
    brewDeleteError: "Falha ao excluir café",
    updating: "Atualizando...",
    deleting: "Excluindo...",
    replaceImage: "Substituir imagem",
    keepCurrentImage: "Manter imagem atual",
    // Lightbox
    closeLightbox: "Fechar",
    // Infinite scroll
    loadingMore: "Carregando mais...",
    noMoreBrews: "Não há mais cafés para carregar",
    // Pull-to-refresh
    pullToRefresh: "Puxe para atualizar",
    releaseToRefresh: "Solte para atualizar",
    refreshing: "Atualizando...",
    // Comments
    comment: "Comentar",
    comments: "Comentários",
    noComments: "Nenhum comentário ainda",
    noCommentsDesc: "Seja o primeiro a compartilhar seus pensamentos!",
    addComment: "Adicione um comentário...",
    postComment: "Publicar",
    posting: "Publicando...",
    commentPosted: "Comentário publicado!",
    commentDeleted: "Comentário excluído",
    commentError: "Falha ao publicar comentário",
    deleteComment: "Excluir comentário",
    deleteCommentConfirm: "Excluir este comentário?",
    characterLimit: "{count}/{max}",
    // Moderation
    commentBlocked: "Comentário bloqueado",
    commentOffensive: "Seu comentário contém linguagem ofensiva",
    commentViolence: "Seu comentário contém conteúdo violento",
    commentHateSpeech: "Seu comentário contém discurso de ódio",
    commentInappropriate: "Seu comentário contém conteúdo inapropriado",
    // Share
    share: "Compartilhar",
    linkCopied: "Link copiado!",
    linkCopiedDesc: "O link do café foi copiado para a área de transferência.",
    shareTitle: "Confira este café no CoffeeLog",
    viewDetails: "Ver Detalhes",
    copy: "Copiar",
    // Brew Detail
    brewInfo: "Informações",
    save: "Salvar",
    like: "Curtir",
    by: "por",
    noPhoto: "Sem foto",
    methodEquipment: "Método e Equipamento",
    showLess: "Mostrar menos",
    showMore: "Mostrar mais",
    copyLinkError: "Falha ao copiar link",
    savedBy: "Salvo por",
    person: "pessoa",
    people: "pessoas",
    recommended: "Recomendado",
    basedOn: "Baseado em",
    rating: "avaliação",
    ratings: "avaliações",
    // Hero Banner
    welcomeBack: "Bem-vindo de volta!",
    welcomeBackDesc: "Pronto para descobrir novos cafés ou compartilhar sua última criação?",
    yourFeed: "Seu Feed",
    latestBrews: "Últimos Cafés",
    explore: "Explorar",
    expandBanner: "Mostrar banner de boas-vindas",
    collapseBanner: "Ocultar banner",
    moreOptions: "Mais opções",
    // Dashboard
    goodMorning: "Bom dia",
    goodAfternoon: "Boa tarde",
    goodEvening: "Boa noite",
    noBrewsToday: "Você ainda não fez nenhum café hoje. Hora do café?",
    allTimeStats: "Estatísticas gerais",
    seeMore: "Ver mais",
    whatBrewing: "O que você está preparando?",
    methods: "Métodos",
    likes: "Curtidas",
    inviteFriends: "Convidar amigos",
    feedback: "Feedback",
    upgrade: "Upgrade",
    // Collection UI
    totalBrews: "cafés",
    totalLikes: "curtidas",
    totalComments: "comentários",
    totalSaved: "salvos",
    searchBrews: "Buscar cafés...",
    filterByMethod: "Método de preparo",
    sortBy: "Ordenar",
    sortRecent: "Mais recentes",
    sortLikes: "Mais curtidos",
    sortAlphabetical: "A-Z",
    viewGrid: "Visualização em grade",
    viewList: "Visualização em lista",
    allMethods: "Todos os métodos",
  },
  settings: {
    title: "Configurações",
    description: "Gerencie sua conta e configurações de perfil",
    profileSettings: "Perfil",
    profileDesc: "Atualize suas informações de perfil",
    avatarUrl: "URL do Avatar",
    avatarHint: "JPG, PNG, WebP ou GIF. Máximo 3MB.",
    usernameNote: "O nome de usuário não pode ser alterado",
    displayName: "Nome de Exibição",
    displayNamePlaceholder: "Seu nome",
    bio: "Bio",
    bioPlaceholder: "Conte-nos sobre você...",
    favoriteGrinder: "Moedor Favorito",
    selectGrinder: "Selecione seu moedor",
    noGrinder: "Nenhum selecionado",
    saving: "Salvando...",
    saveChanges: "Salvar Alterações",
    updateSuccess: "Perfil atualizado!",
    updateError: "Falha ao atualizar perfil",
    changeAvatar: "Alterar Foto",
    removeAvatar: "Remover",
    uploading: "Enviando...",
    avatarUpdated: "Foto de perfil atualizada!",
    avatarRemoved: "Foto de perfil removida",
    avatarTooLarge: "A imagem deve ter menos de 3MB",
    avatarInvalidType: "Apenas JPG, PNG, WebP e GIF são permitidos",
    avatarUploadError: "Falha ao enviar imagem",
    avatarRemoveError: "Falha ao remover imagem",
    cropImage: "Recortar Imagem",
    applyCrop: "Aplicar",
    cropError: "Falha ao recortar imagem",
    preferences: "Preferências",
    language: "Idioma",
    // Account section
    account: "Conta",
    accountDesc: "Gerencie seu email, senha e conta",
    email: "Email",
    changeEmail: "Alterar",
    emailUpdated: "Email atualizado! Verifique sua caixa de entrada para confirmar.",
    emailUpdateError: "Falha ao atualizar email",
    password: "Senha",
    changePassword: "Alterar",
    newPassword: "Nova Senha",
    confirmPassword: "Confirmar Senha",
    passwordUpdated: "Senha atualizada!",
    passwordUpdateError: "Falha ao atualizar senha",
    passwordMismatch: "As senhas não coincidem",
    passwordTooShort: "A senha deve ter pelo menos 6 caracteres",
    deleteAccount: "Excluir Conta",
    deleteAccountDesc: "Exclua permanentemente sua conta e todos os dados",
    deleteAccountConfirm: "Tem certeza que deseja excluir sua conta? Esta ação não pode ser desfeita.",
    accountDeleted: "Conta excluída",
    deleteAccountError: "Falha ao excluir conta",
  },
  imageCropper: {
    title: "Recortar Imagem",
    zoom: "Zoom",
    apply: "Aplicar",
    recrop: "Recortar novamente",
  },
  notifications: {
    title: "Notificações",
    empty: "Nenhuma notificação ainda",
    emptyDesc: "Você verá a atividade dos seus brews aqui",
    markAllRead: "Marcar todas como lidas",
    liked: "@{user} curtiu seu brew",
    commented: "@{user} comentou no seu brew",
    saved: "@{user} salvou seu brew",
    copiedSettings: "@{user} copiou as configurações do seu brew",
    followed: "@{user} começou a seguir você",
    viewAll: "Ver todas as notificações",
  },
  evaluation: {
    title: "Avaliação Sensorial",
    subtitle: "SCA Coffee Value Assessment",
    addEvaluation: "Adicionar Notas de Degustação",
    editEvaluation: "Editar Avaliação",
    removeEvaluation: "Remover Avaliação",
    fragrance: "Fragrância",
    aroma: "Aroma",
    flavor: "Sabor",
    aftertaste: "Finalização",
    acidity: "Acidez",
    sweetness: "Doçura",
    mouthfeel: "Corpo",
    overall: "Geral",
    fragranceDesc: "Cheiro do café seco moído",
    aromaDesc: "Aroma do café molhado",
    aromaNotesPlaceholder: "Descreva os aromas que você detecta...",
    flavorDesc: "Sabor e aroma combinados",
    aftertasteDesc: "Sabores que permanecem após engolir",
    acidityDesc: "Brilho e vivacidade",
    sweetnessDesc: "Doçura natural",
    mouthfeelDesc: "Corpo e textura",
    overallDesc: "Sua impressão pessoal",
    nonUniformCups: "Xícaras não uniformes",
    defectiveCups: "Xícaras defeituosas",
    selectCups: "Selecione as xícaras diferentes",
    defects: "Defeitos",
    defectMoldy: "Mofo",
    defectPhenolic: "Fenólico",
    defectPotato: "Batata",
    score: "Pontuação",
    totalScore: "Pontuação Total",
    averageScore: "Média",
    outOf: "de 9",
    save: "Salvar Avaliação",
    saving: "Salvando...",
    saved: "Avaliação salva!",
    saveError: "Falha ao salvar avaliação",
    removed: "Avaliação removida",
    noEvaluation: "Sem avaliação sensorial ainda",
    noEvaluationDesc: "Adicione suas notas sensoriais para ajudar outros a entender este café.",
    pressTabToComplete: "Pressione Tab para completar",
  },
  illustrations: {
    loginTagline: "Prepare seu café perfeito",
    signupTagline: "Junte-se à comunidade do café",
    calibratorTagline: "Precisão em cada moagem",
  },
  emptyStates: {
    noBrews: {
      title: "Nenhum café ainda",
      description: "Comece a documentar sua jornada do café criando seu primeiro brew.",
      cta: "Criar seu primeiro brew",
    },
    noSaved: {
      title: "Nada salvo",
      description: "Descubra cafés incríveis da comunidade e salve seus favoritos.",
      cta: "Explorar cafés",
    },
    noResults: {
      title: "Nenhum resultado encontrado",
      description: "Tente ajustar sua busca ou filtros.",
    },
    notFound: {
      title: "Página não encontrada",
      description: "Parece que esta página saiu em busca de um café melhor.",
      cta: "Voltar ao início",
    },
  },
  // Dashboard / Roaster translations
  dashboard: {
    // Layout
    overview: "Visão Geral",
    products: "Produtos",
    profiles: "Perfis de Torra",
    integrations: "Integrações",
    settings: "Configurações",
    signOut: "Sair",
    // Dashboard page
    welcomeBack: "Bem-vindo de volta, {name}",
    hereWhatsHappening: "Veja o que está acontecendo com seu feedback",
    totalFeedback: "Total de Feedback",
    averageRating: "Avaliação Média",
    thisWeek: "Esta Semana",
    active: "Ativo",
    recentFeedback: "Feedback Recente",
    productWithLot: "{productName} ({lotNumber})",
    viewAll: "Ver tudo",
    noFeedbackYet: "Nenhum feedback ainda",
    addProductToStart: "Adicione um produto e compartilhe o QR code para começar a coletar feedback",
    yourProducts: "Seus Produtos",
    manage: "Gerenciar",
    noDetails: "Sem detalhes",
    noProductsYet: "Nenhum produto ainda",
    addYourFirstProduct: "Adicione Seu Primeiro Produto",
    // Products page
    manageQrCodes: "Gerencie seus produtos de café e códigos QR",
    addProduct: "Adicionar Produto",
    viewQrCode: "Ver QR Code",
    viewDetails: "Ver Detalhes",
    delete: "Excluir",
    qrCode: "QR Code",
    viewFeedback: "Ver Feedback",
    addFirstProductDesc: "Adicione seu primeiro produto de café para começar a coletar feedback dos clientes.",
    productCard: {
      feedback: "avaliações",
    },
    // Add product dialog
    addNewProduct: "Adicionar Novo Produto",
    createProductDesc: "Crie um produto de café para começar a coletar feedback dos clientes.",
    productImage: "Imagem do Produto",
    productImageHint: "Adicione uma foto do seu café (opcional)",
    coffeeName: "Nome do Café",
    origin: "Origem",
    process: "Processo",
    roastLevel: "Nível de Torra",
    selectRoastLevel: "Selecione o nível de torra",
    description: "Descrição",
    tastingNotesPlaceholder: "Notas de degustação, história da fazenda, etc.",
    cancel: "Cancelar",
    creating: "Criando...",
    createProduct: "Criar Produto",
    productCreated: "Produto criado!",
    failedToCreateProduct: "Falha ao criar produto",
    // Edit product dialog
    editProduct: "Editar Produto",
    editProductDesc: "Atualize os detalhes do seu produto de café.",
    saving: "Salvando...",
    saveProduct: "Salvar Alterações",
    productUpdated: "Produto atualizado!",
    failedToUpdateProduct: "Falha ao atualizar produto",
    // QR dialog
    shareQrCode: "Compartilhe este QR code com seus clientes",
    // Delete dialog
    deleteProduct: "Excluir Produto?",
    deleteProductDesc: "Isso excluirá permanentemente \"{name}\" e todo o feedback associado. Esta ação não pode ser desfeita.",
    deleting: "Excluindo...",
    productDeleted: "Produto excluído",
    failedToDeleteProduct: "Falha ao excluir produto",
    // Product detail
    backToProducts: "Voltar aos Produtos",
    totalReviews: "Total de Avaliações",
    wouldBuyAgain: "Compraria Novamente",
    ratingDistribution: "Distribuição de Avaliações",
    allFeedback: "Todo o Feedback",
    noFeedbackProductYet: "Nenhum feedback ainda",
    shareQrToStart: "Compartilhe o QR code para começar a coletar avaliações",
    getQrCode: "Obter QR Code",
    productNotFound: "Produto não encontrado",
    positiveSentiment: "sentimento positivo",
    negativeSentiment: "sentimento negativo",
    neutralSentiment: "sentimento neutro",
    // Sentiment score
    sentiment: {
      positive: "Positivo",
      neutral: "Neutro",
      negative: "Negativo",
      score: "Score de Sentimento",
      aiAnalysis: "Análise IA",
    },
    // AI Insights Card
    aiInsights: {
      title: "Insights de IA",
      subtitle: "Análise em tempo real do seu feedback",
      avgSentiment: "Score Médio de Sentimento",
      topTopics: "Principais Tópicos Extraídos",
      noTopics: "Nenhum tópico extraído ainda",
      processedFeedback: "{count} de {total} feedback analisados",
    },
    aiDisclaimer: "Insights de IA são apenas para referência. Sempre verifique antes de tomar decisões.",
    aiDisclaimerLink: "Saiba mais",
    // AI Upgrade prompts (for free tier users)
    aiUpgrade: {
      title: "Desbloqueie Insights de IA",
      description: "Faça upgrade para Starter ou Pro para ter análise de sentimento, extração de tópicos e alertas inteligentes com IA.",
      summaryTitle: "Desbloqueie Resumos Semanais",
      summaryDescription: "Faça upgrade para receber resumos semanais gerados por IA com sugestões práticas para seus produtos.",
      button: "Fazer Upgrade",
    },
    // Channel Insights Card
    channelInsights: {
      title: "Performance por Canal",
      subtitle: "Desempenho por canal de compra",
      topPerformer: "Top",
      reviews: "avaliações",
      avgRating: "Nota Média",
      repeatIntent: "Intenção de Recompra",
      positiveSentiment: "Positivo",
    },
    // Health Score
    healthScore: {
      title: "Score de Saúde",
      subtitle: "Desempenho geral do produto",
      excellent: "Excelente",
      good: "Bom",
      fair: "Regular",
      poor: "Ruim",
    },
    // Repeat Analysis
    repeatAnalysis: {
      title: "Análise de Recompra",
      subtitle: "Insights de intenção de recompra",
      overallRepeat: "Intenção Geral de Recompra",
      byChannel: "Por Canal",
      highRatingLowRepeat: "Alta nota, baixa recompra",
      lowRatingHighRepeat: "Baixa nota, alta recompra",
    },
    // Taste Insights
    tasteInsights: {
      title: "Insights de Perfil de Sabor",
      subtitle: "Preferências de sabor e recomendações",
      flavorProfiles: "Perfis de Sabor",
      topTags: "Tags de Melhor Desempenho",
      recommendations: "Recomendações",
      needMoreData: "Colete mais feedback para desbloquear insights de sabor",
      clusterBrightFruity: "Brilhante e Frutado",
      clusterSweetSmooth: "Doce e Suave",
      clusterRichBold: "Rico e Intenso",
      clusterFloralDelicate: "Floral e Delicado",
      clusterComplexSpicy: "Complexo e Picante",
    },
    wouldBuyAgainYes: "Compraria novamente",
    wouldBuyAgainNo: "Não compraria novamente",
    // Roast levels
    light: "Clara",
    mediumLight: "Média-Clara",
    medium: "Média",
    mediumDark: "Média-Escura",
    dark: "Escura",
    // Processes
    washed: "Lavado",
    natural: "Natural",
    honey: "Honey",
    naturalFermented: "Natural Fermentado",
    lateHarvestNatural: "Natural Tardio",
    anaerobicFermentation: "Fermentação Anaeróbica",
    anaerobic: "Anaeróbico",
    other: "Outro",
    select: "Selecionar",
    // Lots
    manageLots: "Gerenciar Lotes",
    manageProductsAndLots: "Gerencie seus produtos de café e lotes de torra",
    // Charts
    charts: {
      sentimentDistribution: "Distribuição de Sentimento",
      ratingTrend: "Tendência de Avaliação",
      feedbackVolume: "Volume de Feedback",
      topTasteTags: "Principais Sabores",
      purchaseChannels: "Canais de Compra",
      aiExtractedTopics: "Tópicos Extraídos por IA",
      aiExtractedTopicsHint: "Temas identificados pela IA nos comentários dos clientes",
      noData: "Nenhum dado disponível ainda",
      noAiTopics: "Nenhum tópico extraído ainda",
      aiTopicsHint: "Os tópicos aparecerão conforme mais feedback for analisado",
      positive: "Positivo",
      neutral: "Neutro",
      negative: "Negativo",
      avgRating: "Avaliação Média",
      feedbackCount: "Feedback",
      mentions: "Menções",
      purchases: "Compras",
      last30Days: "Últimos 30 dias",
      flavorNotes: "Notas de Sabor",
      flavorNotesHint: "Notas de sabor mais mencionadas",
      sensoryProfile: "Perfil Sensorial",
      sensoryProfileHint: "Distribuição de descritores sensoriais",
      tasteRatingCorrelation: "Correlação Sabor-Nota",
      tasteRatingCorrelationHint: "Nota média por etiqueta de sabor",
      wouldBuyAgainTrend: "Tendência de Recompra",
      wouldBuyAgainTrendHint: "Porcentagem de recompra ao longo do tempo",
      percent: "%",
      channels: {
        roasting: "Torrefação",
        online: "Online",
        cafe: "Cafeteria",
        grocery: "Supermercado",
        subscription: "Assinatura",
        gift: "Presente",
        other: "Outro",
      },
    },
  },
  roasterOnboarding: {
    roasterProfile: "Perfil da Torrefadora",
    firstProduct: "Primeiro Produto",
    setupRoasterProfile: "Configure o perfil da sua torrefadora",
    tellUsAboutRoastery: "Conte-nos sobre sua torrefadora",
    roasteryName: "Nome da Torrefadora",
    yourUrl: "Sua URL",
    websiteOptional: "Website (opcional)",
    continue: "Continuar",
    creatingRoaster: "Criando...",
    roasterCreated: "Perfil da torrefadora criado!",
    slugTaken: "URL já em uso",
    chooseAnotherName: "Por favor, escolha um nome diferente ou modifique a URL.",
    failedToCreateRoaster: "Falha ao criar torrefadora",
    addFirstProduct: "Adicione seu primeiro produto",
    createCoffeeToStart: "Crie um café para começar a coletar feedback",
    skipForNow: "Pular por enquanto",
    firstProductReady: "Seu primeiro produto está pronto!",
  },
  roasterSettings: {
    title: "Configurações",
    manageProfileAccount: "Gerencie seu perfil de torrefadora e conta",
    roasterProfile: "Perfil da Torrefadora",
    publicRoasterInfo: "Suas informações públicas de torrefadora",
    logo: "Logo da Torrefadora",
    logoHint: "Envie o logo da sua torrefadora (quadrado, máx 3MB)",
    roasteryName: "Nome da Torrefadora",
    yourUrl: "Sua URL",
    website: "Website",
    saving: "Salvando...",
    saveChanges: "Salvar Alterações",
    settingsSaved: "Configurações salvas",
    urlAlreadyTaken: "URL já em uso",
    failedToSave: "Falha ao salvar alterações",
    subscription: "Assinatura",
    managePlanBilling: "Gerencie seu plano e cobrança",
    free: "Gratuito",
    starter: "Iniciante",
    pro: "Pro",
    freeDesc: "1 produto, 50 feedback/mês",
    starterDesc: "5 produtos, 500 feedback/mês",
    proDesc: "Produtos e lotes ilimitados, 2000 feedback/mês",
    unlimitedDesc: "Ilimitado",
    upgrade: "Fazer Upgrade",
    manageSubscription: "Gerenciar",
    account: "Conta",
    manageAccountSettings: "Gerencie as configurações da sua conta",
    email: "Email",
    fullName: "Nome Completo",
    fullNamePlaceholder: "Digite seu nome completo",
    fullNameSaved: "Nome atualizado",
    fullNameError: "Falha ao atualizar nome",
    signOutTitle: "Sair",
    signOutDesc: "Sair da sua conta",
    deleteAccount: "Excluir Conta",
    deleteAccountDesc: "Excluir permanentemente sua conta e todos os dados",
    deleteAccountConfirm: "Excluir Conta?",
    deleteAccountWarning: "Isso excluirá permanentemente seu perfil de torrefadora, todos os produtos e todo o feedback. Esta ação não pode ser desfeita.",
    accountDeleted: "Conta excluída",
    failedToDeleteAccount: "Falha ao excluir conta",
    // New UX strings
    unsavedChanges: "Alterações não salvas",
    unsavedChangesDesc: "Você tem alterações não salvas. Tem certeza que deseja sair?",
    discardChanges: "Descartar alterações",
    keepEditing: "Continuar editando",
    signOutConfirm: "Sair?",
    signOutConfirmDesc: "Tem certeza que deseja sair da sua conta?",
    profileTab: "Perfil",
    billingTab: "Cobrança",
    accountTab: "Conta",
    urlPreview: "Seu perfil público estará em:",
    slugHint: "Apenas letras minúsculas, números e hífens",
    nameRequired: "Nome é obrigatório",
    slugRequired: "URL é obrigatória",
    slugInvalid: "Apenas letras minúsculas, números e hífens permitidos",
    changesSaved: "Suas alterações foram salvas",
    keyboardShortcut: "Pressione {shortcut} para salvar",
    currentPlan: "Plano atual",
    planFeatures: "Recursos do plano",
    productsLimit: "{count} produtos",
    feedbackLimit: "{count} feedback/mês",
    unlimitedProducts: "Produtos ilimitados",
    unlimitedFeedback: "Feedback ilimitado",
    viewPlans: "Ver todos os planos",
    dangerZone: "Zona de Perigo",
    dangerZoneDesc: "Ações irreversíveis e destrutivas",
    lastSaved: "Salvo {time}",
    neverSaved: "Ainda não salvo",
    // Language settings
    aiLanguage: "Idioma",
    aiLanguageHint: "Idioma da interface do aplicativo e conteúdo gerado por IA",
    languageEnglish: "Inglês",
    languagePortuguese: "Português (Brasil)",
    // Feedback settings
    feedbackSettings: "Configurações de Feedback",
    feedbackSettingsDesc: "Personalize como você lida com feedback dos clientes",
    lowRatingMessage: "Mensagem para Avaliações Baixas",
    lowRatingMessageHint: "Mensagem personalizada exibida para clientes que dão 1-2 estrelas",
    lowRatingMessagePlaceholder: "Sentimos muito pela sua experiência. Valorizamos muito seu feedback e gostaríamos de ter a oportunidade de resolver isso.",
    collectContactOnLowRating: "Coletar contato em avaliações baixas",
    collectContactOnLowRatingDesc: "Perguntar aos clientes insatisfeitos se gostariam de ser contatados",
    rateLimitingEnabled: "Limitação de envios",
    rateLimitingEnabledDesc: "Limita quantas vezes a mesma pessoa pode enviar feedback para prevenir spam e abuso",
    disableRateLimitingTitle: "Desativar limitação de envios?",
    disableRateLimitingWarning: "Sem a limitação de envios, seu formulário de feedback ficará mais vulnerável a envios de spam, bots automatizados e possíveis abusos. Isso pode resultar em dados pouco confiáveis e custos maiores. Desative apenas se tiver um motivo específico, como sessões de cupping organizadas onde muitas avaliações acontecem em pouco tempo.",
    disableRateLimitingConfirm: "Desativar limitação",
    // Endereço
    address: "Endereço da Torrefadora",
    addressHint: "Pesquise o endereço da sua torrefadora",
    addressPlaceholder: "Comece a digitar seu endereço...",
    addressResolveFailed: "Falha ao resolver o endereço. Tente novamente.",
    clearAddress: "Limpar endereço",
    city: "Cidade",
    state: "Estado",
    zip: "CEP",
    country: "País",
    // Links sociais
    socialLinks: "Links Sociais",
    socialLinksDesc: "Conecte seus perfis sociais",
    instagramUrl: "Instagram",
    instagramUrlPlaceholder: "https://instagram.com/sua-torrefadora",
    googleBusinessUrl: "Google Meu Negócio",
    googleBusinessUrlPlaceholder: "https://g.page/sua-torrefadora",
    // Configurações de privacidade
    privacySettings: "Privacidade do Perfil Público",
    privacySettingsDesc: "Controle quais informações de contato são visíveis na sua página pública",
    roasterEmail: "E-mail de Contato",
    roasterEmailHint: "E-mail de contato público (separado do e-mail da sua conta)",
    roasterPhone: "Telefone de Contato",
    roasterPhoneHint: "Número de telefone de contato público",
    shareEmailPublicly: "Mostrar e-mail no perfil público",
    shareEmailPubliclyDesc: "Exibir seu e-mail de contato na página pública da torrefadora",
    sharePhonePublicly: "Mostrar telefone no perfil público",
    sharePhonePubliclyDesc: "Exibir seu telefone de contato na página pública da torrefadora",
  },
  feedbackForm: {
    productNotFound: "Produto Não Encontrado",
    invalidQrCode: "Este QR code é inválido ou o produto não está mais disponível.",
    thankYou: "Obrigado!",
    yourFeedbackHelps: "Seu feedback ajuda {name} a fazer um café melhor.",
    submitAnother: "Enviar Outra Avaliação",
    howWouldYouRate: "Como você avaliaria este café?",
    whatFlavors: "Quais sabores você sentiu? (opcional)",
    additionalThoughts: "Algum pensamento adicional? (opcional)",
    tellUsPlaceholder: "Conte-nos o que você gostou ou o que poderia ser melhor...",
    whereBuy: "Onde você comprou? (opcional)",
    selectPurchaseLocation: "Selecione o local de compra",
    wouldBuyAgain: "Você compraria novamente?",
    yes: "Sim",
    no: "Não",
    pleaseSelectRating: "Por favor, selecione uma avaliação",
    failedToSubmit: "Falha ao enviar feedback. Por favor, tente novamente.",
    submitting: "Enviando...",
    submitFeedback: "Enviar Feedback",
    poweredBy: "Desenvolvido por RoastPulse",
    // Purchase channels
    roasting: "Torrefação",
    online: "Online",
    cafeShop: "Cafeteria",
    groceryStore: "Supermercado",
    subscription: "Assinatura",
    gift: "Presente",
    other: "Outro",
    // Limit reached
    feedbackLimitReached: "Limite de Feedback Atingido",
    feedbackLimitReachedDesc: "{name} atingiu o limite mensal de feedback. Por favor, tente novamente no próximo mês.",
    tryAgainNextMonth: "O formulário de feedback estará disponível novamente no início do próximo mês.",
    // Security errors
    rateLimitExceeded: "Você enviou muitas avaliações. Por favor, tente novamente mais tarde.",
    captchaFailed: "Falha na verificação de segurança. Por favor, atualize a página e tente novamente.",
    // Taste tags
    fruity: "Frutado",
    floral: "Floral",
    sweet: "Doce",
    nutty: "Amendoado",
    chocolatey: "Achocolatado",
    spicy: "Picante",
    earthy: "Terroso",
    citrus: "Cítrico",
    berry: "Frutas Vermelhas",
    caramel: "Caramelo",
    bright: "Brilhante",
    smooth: "Suave",
    bold: "Intenso",
    balanced: "Equilibrado",
    // New flavor notes
    greenVegetative: "Verde/Vegetal",
    sourFermented: "Ácido/Fermentado",
    roasted: "Torrado",
    stoneFruit: "Fruta de caroço",
    tropical: "Tropical",
    driedFruit: "Fruta seca",
    honey: "Mel",
    vanilla: "Baunilha",
    brownSugar: "Açúcar mascavo",
    molasses: "Melaço",
    toffee: "Toffee",
    cocoa: "Cacau",
    cerealMalty: "Cereal/Malte",
    smoky: "Defumado",
    herbal: "Herbal",
    teaLike: "Tipo chá",
    winey: "Vinoso",
    fermented: "Fermentado",
    // New sensory descriptors
    crisp: "Fresco",
    juicy: "Suculento",
    silky: "Sedoso",
    creamy: "Cremoso",
    round: "Redondo",
    delicate: "Delicado",
    clean: "Limpo",
    longFinish: "Final longo",
    dryFinish: "Final seco",
    // Section label
    whatSensations: "Quais sensações você percebeu? (opcional)",
    // Low rating apology section
    sorryToHear: "Sentimos muito pela sua experiência",
    sorryMessage: "Valorizamos muito seu feedback e gostaríamos de ter a oportunidade de resolver isso.",
    wouldYouLikeContact: "Gostaria que entrássemos em contato?",
    contactOptional: "Compartilhar suas informações de contato é completamente opcional",
    yourName: "Seu nome",
    yourEmail: "Seu email",
    yourPhone: "Seu telefone",
    namePlaceholder: "Como podemos te chamar?",
    emailPlaceholder: "seu@email.com",
    phonePlaceholder: "+55 (11) 99999-9999",
  },
  alerts: {
    showLess: "Mostrar menos",
    showMore: "Mostrar mais alertas",
    moreAlerts: "{count} alerta a mais",
    moreAlertsPlural: "{count} alertas a mais",
    dismissAll: "Dispensar todos",
    dismiss: "Dispensar",
    // Alert type labels
    rating_drop: "Queda de Avaliação",
    negative_spike: "Pico Negativo",
    low_volume: "Baixo Volume",
    high_repeat_intent: "Alta Intenção de Recompra",
    channel_mismatch: "Diferença entre Canais",
    emerging_preference: "Preferência Emergente",
  },
  aiSummary: {
    title: "Insights de IA",
    comingSoon: "Em breve...",
    weeklyInsights: "Insights semanais gerados por IA",
    noFeedbackYet: "Quando você tiver mais feedback, a IA gerará resumos semanais e sugestões acionáveis para ajudá-lo a melhorar.",
    weeklyAiSummary: "Resumo Semanal de IA",
    summaryFor: "Resumo semanal de {productName} ({lotNumber})",
    basedOnReviews: "Baseado em {count} avaliações",
    viewLotDetails: "Ver detalhes do lote",
    trendingTopics: "Tópicos em alta:",
    suggestions: "Sugestões",
  },
  roastingInsights: {
    title: "Insights de Torra",
    subtitle: "Análise de IA dos seus perfis de lote",
    basedOnLots: "Baseado em {count} lotes",
    consistencyScore: "Pontuação de consistência",
    suggestions: "Sugestões",
    emptyState: "Adicione lotes com variáveis de torra (temp. de carga, temp. do grão, tempo de torra, etc.) para obter insights de IA sobre consistência, tendências e recomendações.",
    upgradeTitle: "Desbloqueie Insights de Torra",
    upgradeDescription: "Faça upgrade para obter análise de IA dos seus perfis de torra—consistência, tendências, outliers e sugestões acionáveis.",
  },
  lots: {
    // Page
    backToProducts: "Voltar aos Produtos",
    backToLots: "Voltar aos Lotes",
    manageLots: "Gerenciar lotes de torra",
    addLot: "Adicionar Lote",
    noLotsYet: "Nenhum lote ainda",
    addFirstLotDesc: "Crie seu primeiro lote de torra para começar a coletar feedback dos clientes.",
    addYourFirstLot: "Adicione Seu Primeiro Lote",
    noRoastDate: "Sem data de torra",
    // Lot card
    viewQrCode: "Ver QR Code",
    viewDetails: "Ver Detalhes",
    viewFeedback: "Ver Feedback",
    qrCode: "QR Code",
    delete: "Excluir",
    // Add lot dialog
    addNewLot: "Adicionar Novo Lote",
    createLotDesc: "Crie um lote de torra com as variáveis do processo para este batch.",
    lotNumber: "Número do Lote",
    roastedAt: "Data da Torra",
    selectDate: "Selecione uma data",
    // Variables sections
    heatAndTimeVariables: "Variáveis de Calor e Tempo",
    operationalVariables: "Variáveis Operacionais",
    rawMaterialVariables: "Variáveis da Matéria-Prima",
    roastingVariables: "Variáveis de Torra",
    // Roasting variable labels
    chargeTemperature: "Temp. Carga",
    beanTemperature: "Temp. Grão",
    environmentalTemperature: "Temp. Ambiente",
    ambientHumidity: "Umid. Ambiente",
    rateOfRise: "Taxa de Aumento",
    roastTime: "Tempo de Torra",
    airflow: "Fluxo de Ar",
    drumSpeed: "Velocidade do Tambor",
    batchSize: "Tamanho do Lote",
    beanMoisture: "Umidade do Grão",
    beanDensity: "Densidade do Grão",
    selectDensity: "Selecione a densidade",
    roastLevel: "Nível de Torra",
    selectRoastLevel: "Selecione o nível de torra",
    notes: "Observações",
    notesPlaceholder: "Observações adicionais sobre esta torra...",
    // Variable tooltips
    chargeTemperatureTooltip: "A temperatura inicial do tambor do torrador quando o café verde é inserido. Temperaturas mais altas aceleram a torra.",
    beanTemperatureTooltip: "A temperatura medida por uma sonda dentro da massa de grãos. Esta é a medição mais crucial durante a torra.",
    environmentalTemperatureTooltip: "A temperatura do ar dentro do tambor, indicando a rapidez com que a torra está evoluindo.",
    ambientHumidityTooltip: "A porcentagem de umidade no ambiente de torra. Umidade mais alta pode afetar a transferência de calor e o desenvolvimento da torra.",
    rateOfRiseTooltip: "A velocidade com que a temperatura do grão aumenta por minuto. Controlar a RoR (geralmente decrescente) é essencial para evitar torras desiguais.",
    roastTimeTooltip: "A duração total desde a carga até o resfriamento, influenciando o desenvolvimento do sabor. Torras mais longas tendem a desenvolver mais corpo.",
    airflowTooltip: "Controla a exaustão de fumaça e película prateada, além de regular a transferência de calor por convecção. Mais fluxo de ar aumenta a convecção e ajuda a remover sabores de fumaça.",
    drumSpeedTooltip: "Ajusta a agitação dos grãos. Velocidades muito rápidas podem queimar os grãos na parede do tambor; muito lentas podem resultar em agitação insuficiente.",
    batchSizeTooltip: "A quantidade de café colocada no torrador. Cargas maiores exigem mais energia e tempo de torra.",
    beanMoistureTooltip: "Cafés com maior umidade podem exigir uma fase de secagem mais longa e maior energia inicial.",
    beanDensityTooltip: "Grãos mais densos ou com processamentos diferentes (natural, lavado, honey) reagem de forma diferente ao calor.",
    // Density options
    density: {
      low: "Baixa",
      medium: "Média",
      high: "Alta",
    },
    // Actions
    creating: "Criando...",
    createLot: "Criar Lote",
    createLotAndSaveProfile: "Criar Lote e Salvar Perfil",
    lotCreated: "Lote criado!",
    failedToCreateLot: "Falha ao criar lote",
    // QR dialog
    shareQrCode: "Compartilhe este QR code com seus clientes",
    // Delete dialog
    deleteLot: "Excluir Lote?",
    deleteLotDesc: "Isso excluirá permanentemente \"{name}\" e todo o feedback associado. Esta ação não pode ser desfeita.",
    deleting: "Excluindo...",
    lotDeleted: "Lote excluído",
    failedToDeleteLot: "Falha ao excluir lote",
    // Lot detail
    lotNotFound: "Lote não encontrado",
    noFeedbackLotYet: "Nenhum feedback para este lote ainda",
    shareQrToStart: "Compartilhe o QR code para começar a coletar avaliações",
    getQrCode: "Obter QR Code",
    productNotFound: "Produto não encontrado",
    // Import modes
    manualEntry: "Entrada Manual",
    importFromFile: "Importar de Arquivo",
    importPreviewNote: "Selecione um arquivo para visualizar os dados da torra. Você pode revisar e editar antes de criar o lote.",
  },
  // Form validation
  validation: {
    lotNumberRequired: "O número do lote é obrigatório",
    lotNumberTooLong: "O número do lote deve ter no máximo 50 caracteres",
    roastedAtRequired: "A data de torra é obrigatória",
    temperatureRange: "A temperatura deve estar entre 0 e 400°C",
    humidityRange: "A umidade deve estar entre 0 e 100%",
    rorRange: "A taxa de elevação deve estar entre 0 e 50°C/min",
    roastTimeMinutesRange: "Os minutos devem estar entre 0 e 60",
    roastTimeSecondsRange: "Os segundos devem estar entre 0 e 59",
    airflowRange: "O fluxo de ar deve estar entre 0 e 100%",
    drumSpeedRange: "A velocidade do tambor deve estar entre 0 e 200 RPM",
    batchSizeRange: "O tamanho do lote deve estar entre 0 e 500 kg",
    moistureRange: "A umidade deve estar entre 0 e 100%",
    notesTooLong: "As notas devem ter no máximo 1000 caracteres",
  },
  // Profiles feature
  profiles: {
    title: "Perfis de Torra",
    subtitle: "Salve e reutilize suas configurações de torra",
    noRoaster: "Perfil de torrefador não encontrado",
    infoBanner: "Perfis de torra permitem salvar suas configurações favoritas. Ao criar um lote, selecione um perfil para preencher rapidamente o formulário com os valores salvos.",
    // Selector
    loading: "Carregando perfis...",
    selectProfile: "Selecione um perfil",
    noProfiles: "Nenhum perfil salvo",
    manualEntry: "Entrada manual (formulário em branco)",
    productProfiles: "Perfis do produto",
    globalProfiles: "Perfis globais",
    loadFromProfile: "Carregar de perfil",
    // Manager
    noProfilesTitle: "Nenhum perfil salvo",
    noProfilesDescription: "Crie perfis de torra para salvar suas configurações favoritas e reutilizá-las rapidamente ao criar novos lotes.",
    loadError: "Falha ao carregar perfis",
    default: "Padrão",
    // Save dialog
    saveAsProfile: "Salvar como Perfil",
    saveDescription: "Salve sua configuração de torra atual como um perfil reutilizável.",
    name: "Nome do Perfil",
    namePlaceholder: "ex: Torra Clara Padrão",
    description: "Descrição",
    descriptionPlaceholder: "Notas opcionais sobre este perfil...",
    saveForProduct: "Perfil específico do produto",
    saveForProductDescription: "Mostrar este perfil apenas ao criar lotes para este produto",
    setAsDefault: "Definir como padrão",
    setAsDefaultDescription: "Pré-selecionar este perfil ao criar novos lotes",
    nameRequired: "Nome do perfil é obrigatório",
    save: "Salvar Perfil",
    saveSuccess: "Perfil salvo!",
    saveFailed: "Falha ao salvar perfil",
    // Edit dialog
    editProfile: "Editar Perfil",
    editDescription: "Atualize as configurações deste perfil de torra.",
    roastingParameters: "Parâmetros de Torra",
    updateSuccess: "Perfil atualizado!",
    updateFailed: "Falha ao atualizar perfil",
    // Delete
    deleteTitle: "Excluir Perfil?",
    deleteDescription: "Isso excluirá permanentemente \"{name}\". Esta ação não pode ser desfeita.",
    deleteSuccess: "Perfil excluído",
    deleteFailed: "Falha ao excluir perfil",
    // Set default
    setDefaultSuccess: "Perfil definido como padrão",
    setDefaultFailed: "Falha ao definir perfil padrão",
  },
  // Market feature
  market: {
    title: "Mercado de Café",
    subtitle: "Indicador CEPEA/ESALQ de Café Brasileiro",
    types: {
      arabica: "Arábica",
      robusta: "Robusta",
    },
    price: "Preço",
    pricePerBag: "Preço por saca de 60kg",
    bag: "saca",
    daily: "diário",
    monthly: "mensal",
    lastUpdated: "Última atualização",
    source: "Fonte",
    indicator: "Indicador",
    currentPrice: "Preço atual",
    priceAtRoast: "Preço na data da torra",
    coffeeType: "Tipo de Café",
    lotReference: "Referência de Preço de Mercado",
    actions: {
      sync: "Sincronizar preços de mercado",
      retry: "Tentar novamente",
    },
    error: {
      loadFailed: "Falha ao carregar preços de mercado",
    },
    chart: {
      noData: "Sem dados de preço disponíveis",
      last30Days: "Tendência de 30 dias",
    },
    costAnalysis: {
      title: "Análise de Preços de Mercado",
      noData: "Nenhum lote com preços de mercado ainda",
      noDataHint: "Crie lotes com rastreamento de preço de mercado ativado",
      avgPrice: "Preço Médio",
      minPrice: "Preço Mínimo",
      maxPrice: "Preço Máximo",
      lotsTracked: "Lotes Rastreados",
      recentLots: "Lotes Recentes",
    },
  },
  // Integrations feature
  integrations: {
    title: "Integrações",
    subtitle: "Conecte seu software de torra para importar perfis automaticamente",
    connected: "Conectado",
    syncError: "Erro de Sincronização",
    lastSynced: "Última sincronização",
    syncing: "Sincronizando...",
    syncNow: "Sincronizar Agora",
    disconnect: "Desconectar",
    noRoaster: "Perfil de torrefador não encontrado",
    connectedSuccess: "Conectado com sucesso ao {provider}!",
    connectionError: "Falha na conexão: {error}",
    needHelp: "Precisa de Ajuda?",
    helpText: "Cada integração tem requisitos de configuração diferentes. Veja como começar:",
    // Artisan
    artisan: {
      description: "Importe perfis de torra do software Artisan (arquivos .alog)",
      instructions: "Exporte seus perfis de torra do Artisan e envie-os aqui. Os dados serão analisados e você pode criar lotes a partir dos perfis importados.",
      supportedFormats: "Formatos suportados",
      uploadNote: "Arquivos Artisan podem ser enviados diretamente ao criar um novo lote. Vá para Produtos → Selecionar Produto → Adicionar Lote → Importar de Arquivo.",
      helpText: "Exporte torras como arquivos .alog em Arquivo → Exportar → Artisan Log File",
      dragDrop: "Arraste e solte arquivos .alog do Artisan aqui, ou clique para navegar",
      dropHere: "Solte os arquivos aqui...",
      filesSelected: "{count} arquivo(s) selecionado(s)",
      importing: "Importando...",
      importAll: "Importar {count} arquivo(s)",
      allImported: "Todos os {count} arquivos importados com sucesso!",
      importSuccess: "{count} torra(s) importada(s) com sucesso!",
    },
  },
  qrGenerator: {
    printQrCode: "Imprima este QR code nas suas embalagens de café. Os clientes escaneiam para deixar feedback.",
    copyLink: "Copiar Link",
    copyImage: "Copiar Imagem",
    copied: "Copiado!",
    downloadPng: "Baixar PNG",
    scanToRate: "Escaneie para avaliar este café",
    qrCodeDownloaded: "QR code baixado",
    linkCopied: "Link copiado para a área de transferência",
    imageCopied: "Imagem copiada para a área de transferência",
    failedToCopy: "Falha ao copiar link",
    failedToCopyImage: "Falha ao copiar imagem",
  },
  filters: {
    // Date range
    dateRange: "Período",
    last7Days: "Últimos 7 dias",
    last30Days: "Últimos 30 dias",
    last90Days: "Últimos 90 dias",
    yearToDate: "Ano atual",
    customRange: "Período personalizado",
    apply: "Aplicar",
    // Products
    products: "Produtos",
    allProducts: "Todos os Produtos",
    oneProduct: "1 produto",
    productsSelected: "{count} produtos",
    productsAndMore: "{name} +{count} mais",
    searchProducts: "Buscar produtos...",
    noProductsFound: "Nenhum produto encontrado",
    // Lots
    lots: "Lotes",
    allLots: "Todos os lotes",
    oneLot: "1 lote",
    lotsSelected: "{count} lotes",
    lotsAndMore: "{name} +{count} mais",
    searchLots: "Buscar lotes...",
    noLotsFound: "Nenhum lote encontrado",
    selectAll: "Selecionar todos",
    clearAll: "Limpar todos",
    // Sentiment
    sentiment: "Sentimento",
    filterBySentiment: "Filtrar por sentimento",
    sentimentsSelected: "{count} sentimentos",
    // Rating
    rating: "Avaliação",
    filterByRating: "Filtrar por avaliação",
    ratingsSelected: "{count} avaliações",
    stars: "estrelas",
    // Channel
    channel: "Canal",
    filterByChannel: "Filtrar por canal de compra",
    channelsSelected: "{count} canais",
    // Compare
    compare: "Comparar",
    compareOff: "Comparar: Desligado",
    comparePeriod: "Comparar períodos",
    compareProduct: "Comparar produtos",
    comparing: "Comparando",
    comparingProducts: "Comparando produtos",
    vs: "vs",
    selectProductToCompare: "Selecione um produto para comparar",
    selectedProducts: "Produtos selecionados",
    compareWith: "Comparar com",
    // General
    filters: "Filtros",
    activeFilters: "{count} filtros ativos",
    reset: "Limpar",
    applyFilters: "Aplicar Filtros",
    scope: "Escopo",
    feedbackFilters: "Filtrar por feedback",
    noProductsYet: "Nenhum produto ainda",
    noLotsForProducts: "Nenhum lote para os produtos selecionados",
    addLotsHint: "Adicione lotes em Produtos",
    clearAllFilters: "Limpar tudo",
    removeFilter: "Remover filtro",
    // Comparison labels
    current: "Atual",
    comparison: "Comparação",
    previous: "Anterior",
    change: "Variação",
    // Export
    export: "Exportar",
    exportCsv: "Exportar CSV",
    exportPdf: "Exportar PDF",
    share: "Compartilhar",
    shareDashboard: "Compartilhar Dashboard",
    linkCopied: "Link copiado!",
    copyLink: "Copiar Link",
  },
  followUp: {
    title: "Fila de Acompanhamento",
    subtitle: "Avaliações negativas dos clientes para acompanhar e resolver",
    pending: "pendentes",
    needsAction: "Requer ação",
    completed: "Concluído",
    loadingItems: "Carregando itens...",
    new: "Novo",
    inProgress: "Em Andamento",
    resolved: "Resolvido",
    dismissed: "Descartado",
    allCaughtUp: "Tudo em dia!",
    noNegativeFeedback: "Nenhum feedback negativo requer acompanhamento",
    sendEmail: "Enviar Email",
    updateStatus: "Atualizar",
    viewAll: "Ver todos ({count})",
    updateStatusTitle: "Atualizar Status do Acompanhamento",
    notes: "Notas",
    notesPlaceholder: "Adicione notas sobre a ação de acompanhamento...",
    markInProgress: "Em Andamento",
    markResolved: "Resolvido",
    dismiss: "Descartar",
    statusUpdated: "Status atualizado",
    statusUpdatedDesc: "O status do acompanhamento foi atualizado",
    updateError: "Falha ao atualizar status",
  },
  home: {
    // Header
    signIn: "Entrar",
    getStarted: "Começar",
    // Hero
    heroTitle: "Saiba o que seus clientes pensam",
    heroSubtitle: "Colete feedback diretamente dos apreciadores de café. Obtenha insights com IA para melhorar suas torras e fazer seu negócio crescer.",
    startFreeTrial: "Começar Grátis",
    seeDemo: "Ver Demo",
    freeNote: "Grátis para 1 produto. Sem cartão de crédito.",
    // How it works
    howItWorks: "Como funciona",
    step1Title: "Adicione QR às suas embalagens",
    step1Desc: "Gere QR codes únicos para cada produto de café. Imprima-os nas suas embalagens ou etiquetas.",
    step2Title: "Clientes escaneiam e avaliam",
    step2Desc: "Um formulário simples e otimizado para celular. Sem baixar app. 30 segundos para completar.",
    step3Title: "Obtenha insights acionáveis",
    step3Desc: "Veja avaliações, tendências e análises com IA do que os clientes amam (e do que não amam).",
    // Features
    aiPoweredInsights: "Insights com IA",
    sentimentAnalysis: "Análise de Sentimento",
    sentimentAnalysisDesc: "Categorize automaticamente o feedback como positivo, neutro ou negativo. Acompanhe tendências de sentimento ao longo do tempo.",
    topicExtraction: "Extração de Tópicos",
    topicExtractionDesc: "A IA identifica o que os clientes comentam: sabor, frescor, embalagem, custo-benefício e mais.",
    weeklySummaries: "Resumos Semanais",
    weeklySummariesDesc: "Receba um resumo claro do seu feedback. Saiba exatamente o que está funcionando e o que precisa de atenção.",
    qualityAlerts: "Alertas de Qualidade",
    qualityAlertsDesc: "Seja notificado quando as avaliações caírem. Detecte problemas de qualidade antes que se tornem grandes.",
    // Pricing
    simplePricing: "Planos",
    pricingSubtitle: "Comece grátis com 1 produto. Faça upgrade conforme crescer.",
    free: "Grátis",
    forever: "para sempre",
    freeFeature1: "1 produto",
    freeFeature2: "50 feedback/mês",
    freeFeature3: "Analytics básico",
    popular: "Popular",
    starter: "Iniciante",
    starterFeature1: "5 produtos",
    starterFeature2: "500 feedback/mês",
    starterFeature3: "Insights com IA",
    starterAiFeatures: ["Análise de sentimento", "Extração de tópicos"],
    pro: "Pro",
    proFeature1: "Produtos e lotes ilimitados",
    proFeature2: "2000 feedback/mês",
    proFeature3: "Suíte completa de IA",
    proAiFeatures: ["Resumos semanais com IA", "Sugestões práticas", "Alertas inteligentes"],
    proAiIncludesStarter: "Inclui recursos de IA do Starter",
    product: "produto",
    products: "produtos",
    lots: "lotes",
    unlimitedProducts: "Produtos ilimitados",
    unlimitedFeedback: "Feedback ilimitado",
    withYearlyBilling: "no plano anual",
    allPlansInclude: "Todos os planos incluem geração de QR codes e acesso ao painel. Recursos de IA disponíveis no Starter e Pro.",
    perMonth: "/mês",
    // Footer
    copyright: "© {year} RoastPulse. Todos os direitos reservados.",
    footerTagline: "A plataforma de feedback feita para torrefadores de café. Entenda seus clientes, melhore seus produtos.",
    footerProduct: "Produto",
    footerFeatures: "Funcionalidades",
    footerPricing: "Preços",
    footerCompany: "Empresa",
    footerAbout: "Sobre",
    footerContact: "Contato",
    footerLegal: "Legal",
    footerPrivacy: "Política de Privacidade",
    footerTerms: "Termos de Uso",
    footerNewsletter: "Fique Atualizado",
    footerNewsletterDesc: "Receba novidades e insights da indústria do café.",
    footerEmailPlaceholder: "Digite seu email",
    footerSubscribe: "Inscrever",
    // Benefits section
    benefits: "Principais Benefícios",
    benefitsSubtitle: "Tudo que você precisa para entender seus clientes",
    effortlessFeedback: "Coleta de Feedback sem Esforço",
    effortlessFeedbackDesc: "Gere QR codes para suas embalagens. Clientes enviam feedback em 60 segundos - sem precisar de conta.",
    understandCustomers: "Entenda Melhor seus Clientes",
    understandCustomersDesc: "Veja quais perfis de sabor mais agradam, acompanhe canais de compra e saiba quais produtos geram recompra.",
    aiInsightsTitle: "Insights com Inteligência Artificial",
    aiInsightsDesc: "Análise automática de sentimento, extração de tópicos e resumos semanais. Sem trabalho manual.",
    earlyWarning: "Sistema de Alerta Antecipado",
    earlyWarningDesc: "Receba alertas quando as avaliações caírem, detecte picos negativos antes que se tornem problemas.",
    analyticsDashboard: "Painel de Análises Profissional",
    analyticsDashboardDesc: "Visualize avaliações, tendências e comparações. Filtre por data, produto, sentimento ou canal.",
    multilingualSupport: "Suporte Multilíngue",
    multilingualSupportDesc: "Disponível em Português e Inglês. Atenda clientes internacionais no idioma preferido deles.",
    // What makes different section
    whatMakesDifferent: "O que Torna o RoastPulse Diferente",
    madeForCoffee: "Feito para Café",
    madeForCoffeeDesc: "Desenvolvido para torrefadores de café, não é uma ferramenta genérica. Inclui tags de sabor específicas para café.",
    zeroFriction: "Zero Fricção",
    zeroFrictionDesc: "Sem download de app, sem criar conta. Clientes apenas escaneiam e avaliam.",
    aiWorksForYou: "IA que Trabalha por Você",
    aiWorksForYouDesc: "Análise automática significa que você não precisa ler cada comentário manualmente.",
    actionableData: "Acionável, Não Apenas Dados",
    actionableDataDesc: "Receba sugestões específicas, não apenas números e gráficos.",
    growsWithYou: "Cresce com Você",
    growsWithYouDesc: "De pequenos torrefadores artesanais a grandes operações.",
    respectsPrivacy: "Respeita a Privacidade",
    respectsPrivacyDesc: "Opção de feedback anônimo constrói confiança do cliente.",
  },
  privacy: {
    title: "Política de Privacidade",
    lastUpdated: "Última atualização",
    backToHome: "Voltar",
    allRightsReserved: "Todos os direitos reservados.",
    viewTerms: "Ver Termos de Uso",
    email: "Email",
    // Introduction
    introTitle: "1. Introdução",
    introText: "A RoastPulse está comprometida em proteger sua privacidade. Esta Política de Privacidade explica como coletamos, usamos, divulgamos e protegemos suas informações quando você usa nossa plataforma de feedback para torrefadores de café. Esta política está em conformidade com a Lei Geral de Proteção de Dados (LGPD - Lei nº 13.709/2018).",
    // Data Controller
    controllerTitle: "2. Controlador de Dados",
    controllerText: "O controlador de dados responsável pelo processamento de seus dados pessoais é:",
    // Data Collected
    dataCollectedTitle: "3. Dados que Coletamos",
    roasterDataTitle: "Para Torrefadores (Usuários Comerciais)",
    roasterData1: "Dados de autenticação (email e senha criptografada)",
    roasterData2: "Dados de perfil (nome de usuário, nome de exibição, foto de perfil, biografia)",
    roasterData3: "Dados comerciais (nome da torrefadora, logo, site, slug)",
    roasterData4: "Dados de pagamento (identificador de cliente Stripe para processamento de assinaturas)",
    consumerDataTitle: "Para Consumidores (Enviando Feedback)",
    consumerData1: "Conteúdo do feedback (avaliação, comentário, tags de sabor, canal de compra, intenção de recompra)",
    consumerData2: "Email (opcional, para acompanhamento - o feedback é anônimo por padrão)",
    consumerData3: "Dados processados por IA (pontuação de sentimento, rótulo de sentimento, tópicos extraídos)",
    // Data Use
    dataUseTitle: "4. Como Usamos Seus Dados",
    dataUse1: "Para fornecer e manter nosso serviço de plataforma de feedback",
    dataUse2: "Para processar e analisar feedback usando inteligência artificial",
    dataUse3: "Para gerar insights, resumos e recomendações para torrefadores",
    dataUse4: "Para processar pagamentos e gerenciar assinaturas",
    dataUse5: "Para nos comunicar com você sobre sua conta e atualizações do serviço",
    // Legal Basis
    legalBasisTitle: "5. Base Legal para Processamento (LGPD Art. 7)",
    legalBasisIntro: "Processamos seus dados pessoais com base nos seguintes fundamentos legais:",
    legalBasis1Label: "Execução de Contrato",
    legalBasis1Text: "Para fornecer nossos serviços conforme acordado quando você criou sua conta",
    legalBasis2Label: "Consentimento",
    legalBasis2Text: "Para processamento opcional, como comunicações de marketing (você pode retirar a qualquer momento)",
    legalBasis3Label: "Interesse Legítimo",
    legalBasis3Text: "Para melhorar nossos serviços e prevenir fraudes",
    // Data Sharing
    dataSharingTitle: "6. Compartilhamento de Dados",
    dataSharingIntro: "Podemos compartilhar seus dados com os seguintes provedores de serviços terceirizados:",
    dataSharing1: "Serviços de banco de dados e autenticação em nuvem",
    dataSharing2: "Processamento de pagamentos para assinaturas",
    dataSharing3: "Análise de sentimento e processamento de linguagem natural",
    aiProviders: "Provedores de IA",
    // AI Processing and User Responsibility
    aiProcessingTitle: "Processamento por IA e Responsabilidade do Usuário",
    aiProcessingText: "Quando o feedback é enviado, ele é automaticamente processado por sistemas de IA (fornecidos pela OpenAI) para gerar pontuações de sentimento, extrair tópicos e criar resumos. Esse processamento ajuda a fornecer insights sobre padrões de feedback dos clientes.",
    aiProcessingDisclaimer: "Importante: Métricas, insights e sugestões gerados por IA são resultados algorítmicos baseados em reconhecimento de padrões e processamento de linguagem natural. Eles não são garantias de precisão e podem conter erros ou interpretações equivocadas. Você é responsável por revisar e verificar todos os insights gerados por IA antes de tomar qualquer decisão de negócios. Os resultados de IA devem ser usados como ferramenta de referência, não como a única base para ação.",
    // Retention
    retentionTitle: "7. Retenção de Dados",
    retentionText: "Retemos seus dados pessoais apenas pelo tempo necessário para cumprir os propósitos descritos nesta política. Os dados da conta são mantidos enquanto sua conta estiver ativa. Os dados de feedback são retidos para fornecer análises e insights aos torrefadores. Você pode solicitar a exclusão de seus dados a qualquer momento.",
    // Rights
    rightsTitle: "8. Seus Direitos (LGPD Art. 18)",
    rightsIntro: "Sob a LGPD, você tem os seguintes direitos em relação aos seus dados pessoais:",
    rights1: "Confirmação de existência de tratamento de dados",
    rights2: "Acesso aos seus dados pessoais",
    rights3: "Correção de dados incompletos, inexatos ou desatualizados",
    rights4: "Anonimização, bloqueio ou eliminação de dados desnecessários ou excessivos",
    rights5: "Portabilidade dos dados a outro fornecedor de serviço",
    rights6: "Eliminação dos dados pessoais tratados com consentimento",
    rights7: "Revogação do consentimento a qualquer momento",
    rightsContact: "Para exercer qualquer um desses direitos, entre em contato conosco através das informações de contato fornecidas abaixo.",
    // Cookies
    cookiesTitle: "9. Cookies e Tecnologias de Rastreamento",
    cookiesText: "Usamos cookies essenciais para gerenciamento de sessão e autenticação. Não usamos cookies de rastreamento de terceiros para publicidade. Você pode gerenciar as preferências de cookies através das configurações do seu navegador.",
    // Security
    securityTitle: "10. Segurança de Dados (LGPD Art. 46)",
    securityText: "Implementamos medidas técnicas e organizacionais apropriadas para proteger seus dados pessoais contra acesso não autorizado, alteração, divulgação ou destruição. Isso inclui criptografia, controles de acesso e auditorias regulares de segurança.",
    // Changes
    changesTitle: "11. Alterações nesta Política",
    changesText: "Podemos atualizar esta Política de Privacidade periodicamente. Notificaremos sobre quaisquer alterações materiais publicando a nova política em nosso site e atualizando a data de \"Última atualização\". Recomendamos revisar esta política periodicamente.",
    // Contact
    contactTitle: "12. Contato",
    contactText: "Se você tiver dúvidas sobre esta Política de Privacidade ou quiser exercer seus direitos de proteção de dados, entre em contato conosco:",
  },
  billing: {
    // General
    used: "usado",
    products: "Produtos",
    lots: "Lotes",
    feedbackThisMonth: "Feedback este mês",
    // Read-only mode (excess products)
    readOnly: "Somente leitura",
    overLimitBanner: "Você tem {count} produtos acima do limite do seu plano de {limit}.",
    upgradeToUnlock: "Faça upgrade para desbloquear",
    productReadOnlyBanner: "Este produto está acima do limite do seu plano. Edição desabilitada e novos feedbacks estão ocultos.",
    // Hidden feedback teaser
    hiddenFeedbackCount: "{count} novos feedbacks ocultos",
    hiddenFeedbackSubtitle: "Enviados desde o término da sua assinatura",
    unlockBenefit1: "Ver todo o conteúdo dos feedbacks",
    unlockBenefit2: "Insights e análises com IA",
    upgradeToSee: "Faça upgrade para ver feedbacks",
    // Pricing
    choosePlan: "Escolha Seu Plano",
    choosePlanDescription: "Selecione o plano que melhor se adapta à sua torrefadora",
    monthly: "Mensal",
    yearly: "Anual",
    month: "mês",
    billedYearly: "cobrado anualmente",
    year: "ano",
    savePercent: "Economize {percent}%",
    savingsPerYear: "Você economiza {amount}/ano",
    recommended: "Recomendado",
    currentPlan: "Plano Atual",
    selectPlan: "Selecionar Plano",
    processing: "Processando...",
    upgradeNow: "Fazer Upgrade Agora",
    upgrade: "Fazer Upgrade",
    downgrade: "Fazer Downgrade",
    cancelSubscription: "Cancelar Assinatura",
    cancelSubscriptionConfirmTitle: "Cancelar Assinatura?",
    cancelSubscriptionConfirmDescription: "Sua assinatura {plan} permanecerá ativa até {date}. Após essa data, você será transferido para o plano Gratuito e não será mais cobrado.",
    cancelSubscriptionConfirm: "Sim, cancelar assinatura",
    cancelSubscriptionCancel: "Manter minha assinatura",
    canceling: "Cancelando...",
    downgradeSuccess: "Seu plano será alterado para Starter no final do período de cobrança.",
    downgradeError: "Falha ao fazer downgrade. Tente novamente.",
    downgradeScheduled: "Downgrade agendado",
    downgradeScheduledMessage: "Seu plano será alterado para {tier} em {date}.",
    downgradeScheduledStatus: "Seu plano será alterado para {tier} no final do período de cobrança.",
    cancelSuccess: "Sua assinatura foi cancelada. Você manterá acesso até o final do seu período de cobrança.",
    cancelError: "Falha ao cancelar assinatura. Por favor, tente novamente.",
    free: "Gratuito",
    cancelAnytime: "Cancele quando quiser. Sem perguntas.",
    // Plan features
    unlimitedProducts: "Produtos ilimitados",
    unlimitedLots: "Lotes ilimitados",
    unlimitedFeedback: "Feedback ilimitado",
    upToProducts: "Até {count} produtos",
    upToLots: "Até {count} lotes",
    upToFeedback: "Até {count} feedback/mês",
    aiAnalysis: "Análise com IA",
    noAiAnalysis: "Sem análise de IA",
    qrCodes: "Geração de QR codes",
    prioritySupport: "Suporte prioritário",
    // Subscription details
    subscriptionDetails: "Detalhes da Assinatura",
    billingCycle: "Ciclo de Cobrança",
    price: "Preço",
    nextBillingDate: "Próxima Data de Cobrança",
    cancelingAtPeriodEnd: "Sua assinatura será cancelada no final do período de cobrança",
    subscriptionCanceled: "Cancelada",
    canceledStatus: "Sua assinatura foi cancelada",
    cancellationScheduled: "Cancelamento Agendado",
    cancellationScheduledStatus: "Sua assinatura está agendada para cancelar",
    subscriptionEndedStatus: "Sua assinatura foi encerrada",
    subscriptionEndedDescription: "Sua assinatura foi cancelada. Você terá acesso ao plano {plan} até {date}, após essa data você será transferido para o plano Gratuito.",
    accessUntil: "Você terá acesso aos recursos do plano {plan} até {date}",
    afterCancellation: "Após esta data, sua conta mudará para o plano Gratuito",
    reactivateSubscription: "Reativar Assinatura",
    reactivateSubscriptionConfirmTitle: "Reativar assinatura?",
    reactivateSubscriptionConfirmDescription: "Seu plano {plan} será reativado e será renovado em {date}. Você continuará sendo cobrado no final de cada período de cobrança.",
    reactivateSubscriptionConfirm: "Sim, reativar",
    reactivateSubscriptionCancel: "Manter cancelamento",
    reactivateSuccess: "Sua assinatura foi reativada.",
    reactivateError: "Falha ao reativar assinatura. Tente novamente.",
    currentUsage: "Uso Atual",
    // Upgrade modal
    limitReached: "Você atingiu seu limite",
    limitReachedDescription: "Você usou {current} de {limit} {type}. Faça upgrade para continuar.",
    productsLimit: "produtos",
    lotsLimit: "lotes",
    feedbackLimit: "feedback",
    // Upgrade prompt
    upgradePromptTitle: "Desbloqueie mais recursos",
    upgradePromptDescription: "Faça upgrade para um plano pago e tenha mais produtos, feedback e economize {percent}% com cobrança anual.",
  },
  terms: {
    title: "Termos de Uso",
    lastUpdated: "Última atualização",
    backToHome: "Voltar",
    allRightsReserved: "Todos os direitos reservados.",
    viewPrivacy: "Ver Política de Privacidade",
    email: "Email",
    // Acceptance
    acceptanceTitle: "1. Aceitação dos Termos",
    acceptanceText: "Ao acessar ou usar a plataforma RoastPulse, você concorda em estar vinculado a estes Termos de Uso. Se você não concordar com qualquer parte destes termos, não poderá acessar ou usar nossos serviços. Estes termos são regidos pela legislação brasileira.",
    // Service
    serviceTitle: "2. Descrição do Serviço",
    serviceText: "O RoastPulse é uma plataforma de coleta e análise de feedback projetada especificamente para torrefadores de café. Nosso serviço inclui:",
    service1: "Geração de QR codes para coleta de feedback de produtos",
    service2: "Análise de feedback com inteligência artificial",
    service3: "Painéis de análise e relatórios",
    service4: "Sistema de alertas para anomalias em avaliações",
    // Account
    accountTitle: "3. Registro e Responsabilidades da Conta",
    accountText: "Ao criar uma conta, você concorda em:",
    account1: "Fornecer informações precisas e completas",
    account2: "Manter a segurança das credenciais da sua conta",
    account3: "Notificar-nos imediatamente sobre qualquer uso não autorizado",
    account4: "Ser responsável por todas as atividades em sua conta",
    // Acceptable Use
    acceptableUseTitle: "4. Uso Aceitável",
    acceptableUseText: "Você concorda em NÃO usar nossa plataforma para:",
    acceptableUse1: "Violar quaisquer leis ou regulamentos aplicáveis",
    acceptableUse2: "Coletar feedback falso ou manipular avaliações",
    acceptableUse3: "Fazer upload de conteúdo malicioso ou spam",
    acceptableUse4: "Tentar obter acesso não autorizado aos nossos sistemas",
    acceptableUse5: "Usar os dados de maneira que viole direitos de privacidade de terceiros",
    // IP
    ipTitle: "5. Propriedade Intelectual",
    ipText: "A plataforma RoastPulse, incluindo seu design, recursos, código e conteúdo (excluindo conteúdo gerado pelo usuário), é propriedade da RoastPulse e está protegida por leis de propriedade intelectual. Você não pode copiar, modificar, distribuir ou criar trabalhos derivados sem nossa autorização expressa por escrito.",
    // User Content
    userContentTitle: "6. Conteúdo do Usuário",
    userContentText: "Você mantém a propriedade do conteúdo que envia, incluindo informações de produtos e dados comerciais. Ao usar nosso serviço, você nos concede uma licença para usar, processar e exibir seu conteúdo conforme necessário para operar a plataforma. O feedback dos consumidores é coletado em nome dos torrefadores e processado de acordo com nossa Política de Privacidade.",
    // Payment
    paymentTitle: "7. Termos de Pagamento",
    paymentText: "Para planos de assinatura pagos:",
    payment1: "Os pagamentos são processados de forma segura através do Stripe",
    payment2: "As assinaturas são renovadas automaticamente, salvo se canceladas",
    payment3: "Reembolsos são tratados caso a caso de acordo com nossa política de reembolso",
    // AI-Powered Features
    aiTitle: "8. Recursos de IA e Responsabilidade do Usuário",
    aiIntro: "A RoastPulse oferece recursos com inteligência artificial para ajudá-lo a analisar e compreender o feedback dos clientes. É essencial que você entenda a natureza e as limitações desses recursos.",
    aiFeatures: "Nossos recursos de IA incluem:",
    aiFeature1: "Análise de sentimento do feedback dos clientes",
    aiFeature2: "Extração e categorização de tópicos",
    aiFeature3: "Resumos semanais e sugestões acionáveis",
    aiFeature4: "Detecção de anomalias e alertas",
    aiProviderNote: "Esses recursos são fornecidos por provedores de IA terceirizados confiáveis (como a OpenAI) que empregam práticas de segurança e privacidade padrão da indústria. Embora selecionemos provedores confiáveis, a tecnologia de IA possui limitações inerentes.",
    aiUserResponsibility: "Responsabilidade do Usuário:",
    aiResponsibility1: "Insights, métricas e sugestões gerados por IA são fornecidos apenas como ferramentas auxiliares e devem ser tratados como ponto de partida para sua análise, não como conclusões definitivas.",
    aiResponsibility2: "Você deve verificar e validar independentemente todos os insights gerados por IA antes de tomar qualquer ação. A análise de IA pode conter imprecisões, interpretações equivocadas ou erros.",
    aiResponsibility3: "Use os resultados de IA como base ou ponto de referência. Sempre aplique seu próprio julgamento comercial e expertise ao tomar decisões.",
    aiResponsibility4: "Você assume total responsabilidade por quaisquer decisões comerciais, ações ou estratégias baseadas em insights gerados por IA. A RoastPulse não garante a precisão, completude ou adequação dos resultados de IA para suas necessidades específicas.",
    aiResponsibility5: "A RoastPulse não será responsável por quaisquer perdas, danos ou consequências decorrentes de ações tomadas com base em insights gerados por IA.",
    aiAcknowledgment: "Ao usar nossos recursos de IA, você reconhece que leu, compreendeu e concorda com estes termos referentes à funcionalidade com inteligência artificial.",
    // Disclaimer
    disclaimerTitle: "9. Isenção de Garantias",
    disclaimerText: "O serviço é fornecido \"como está\" e \"conforme disponível\" sem garantias de qualquer tipo, expressas ou implícitas. Não garantimos que o serviço será ininterrupto, seguro ou livre de erros.",
    // Liability
    liabilityTitle: "10. Limitação de Responsabilidade",
    liabilityText: "Na extensão máxima permitida pela lei brasileira, a RoastPulse não será responsável por quaisquer danos indiretos, incidentais, especiais, consequenciais ou punitivos, incluindo perda de lucros, dados ou oportunidades de negócios, decorrentes do uso ou incapacidade de usar nosso serviço.",
    // Termination
    terminationTitle: "11. Encerramento",
    terminationText: "Podemos suspender ou encerrar sua conta se você violar estes termos ou por qualquer outro motivo a nosso exclusivo critério. Após o encerramento, seu direito de usar o serviço cessará imediatamente. Você pode encerrar sua conta a qualquer momento através das configurações da conta.",
    // Governing Law
    governingLawTitle: "12. Lei Aplicável",
    governingLawText: "Estes Termos de Uso são regidos e interpretados de acordo com as leis da República Federativa do Brasil. Quaisquer disputas decorrentes destes termos estarão sujeitas à jurisdição exclusiva dos tribunais brasileiros.",
    // Dispute
    disputeTitle: "13. Resolução de Disputas",
    disputeText: "Quaisquer disputas ou reclamações decorrentes ou relacionadas a estes termos devem primeiro ser tratadas através de negociação de boa-fé. Se uma resolução não puder ser alcançada, as disputas serão resolvidas através de arbitragem ou nos tribunais competentes do Brasil, conforme a legislação aplicável.",
    // Changes
    changesTitle: "14. Alterações nos Termos",
    changesText: "Reservamo-nos o direito de modificar estes termos a qualquer momento. As alterações entrarão em vigor após a publicação dos termos atualizados em nosso site. O uso continuado do serviço após quaisquer alterações constitui aceitação dos novos termos.",
    // Contact
    contactTitle: "15. Contato",
    contactText: "Se você tiver dúvidas sobre estes Termos de Uso, entre em contato conosco:",
  },

  // Página pública da torrefadora
  publicPage: {
    poweredBy: "Feito com RoastPulse",
    products: "Nossos Cafés",
    noProducts: "Nenhum produto disponível ainda.",
    noProductsSubtext: "Volte em breve — novos cafés estão a caminho!",
    customerFeedback: "Avaliações dos Clientes",
    noFeedback: "Nenhuma avaliação ainda.",
    noFeedbackSubtext: "Seja o primeiro a compartilhar sua experiência!",
    lotLabel: "Lote",
    reviews: "avaliações",
    review: "avaliação",
    visitWebsite: "Visitar Site",
    roasterNotFound: "Torrefadora não encontrada",
    roasterNotFoundSubtext: "A página que você procura não existe ou pode ter sido movida.",
    allProducts: "Todos os Produtos",
    showFeedback: "Ver Avaliações",
    hideFeedback: "Ocultar Avaliações",
    averageRating: "média",
    location: "Localização",
    contactUs: "Contato",
    viewOnMap: "Ver no mapa",
    seeAllReviews: "Ver todas as {count} avaliações",
    seeAllReviewsSingular: "Ver a avaliação",
    ratingBreakdown: "Distribuição de Notas",
    basedOnReviews: "Baseado em {count} avaliações",
    basedOnReviewSingular: "Baseado em 1 avaliação",
    stars: "estrelas",
    star: "estrela",
    clearFilter: "Limpar",
  },
} as const;
